import xior from "xior";
import { useToken } from "@/hooks/useToken";

const rawBase = import.meta.env.VITE_BACKEND_BASE_URL;
if (!rawBase || typeof rawBase !== "string" || !/^https?:\/\//i.test(rawBase.trim())) {
    throw new Error(
        "VITE_BACKEND_BASE_URL must be set in tinytalk-frontend/.env (e.g. http://localhost:3000)"
    );
}
const backendBaseUrl = rawBase.replace(/\/$/, "");

const api = xior.create({
    baseURL: `${backendBaseUrl}/api/v1`,
    headers: {
        "Content-Type": "application/json",
    },
    withCredentials: false, // Do not allow to parse the cookies from the api
});

api.interceptors.request.use(
    (config) => {
        const token = useToken();

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        config.headers['api-key'] = import.meta.env.VITE_API_KEY;

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;